import { FormControl, InputLabel, OutlinedInput } from "@mui/material";
import dayjs from "dayjs";
import { forwardRef } from "react";
import { Controller, UseFormReturn } from "react-hook-form";
import { IMask, IMaskInput } from "react-imask";

/**
 * FormTimeMaskedInputBase
 */
interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  mask: string;
}

const FormTimeMaskedInputBase = forwardRef<HTMLInputElement, CustomProps>((props, refs) => {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      placeholder="_"
      inputRef={refs}
      onAccept={(value: any, input: { unmaskedValue: string }) => {
        if (input.unmaskedValue.length > 0) {
          onChange({ target: { name: props.name, value } });
        } else {
          onChange({ target: { name: props.name, value: '' } });
        }
      }}
      lazy={false}
      overwrite={true}
      unmask={false}
    />
  );
});


/**
 * FormTimeMaskedInput
 */

type Props<T extends {},> = {
  name: keyof T,
  label: string,
  required?: boolean,
  readOnly?: boolean,
  reactHookForm: UseFormReturn<T>,
};

export const FormTimeMaskedInput = <T extends {},>({
  name,
  label,
  required,
  readOnly,
  reactHookForm,
}: Props<T>) => {
  return (
    <Controller
      name={name as any}
      control={reactHookForm.control}
      render={({ field }) => {
        let normalizedValue = '';
        if (typeof field.value === 'string') {
          normalizedValue = field.value;
        } else if (typeof field.value === 'number') {
          const duration = dayjs.duration(field.value, 'minutes');
          normalizedValue = duration.format("HH:mm");
        }
        return (
          <FormControl variant="outlined" size="small" required={required}>
            <InputLabel htmlFor={`input-${name as string}`} shrink={true} size="small" required={required}>{label}</InputLabel>
            <OutlinedInput
              size="small"
              id={`input-${name as string}`}
              name={name as string}
              value={normalizedValue}
              label={label}
              notched={true}
              required={required}
              onChange={field.onChange}
              readOnly={readOnly}
              inputComponent={FormTimeMaskedInputBase as any}
              inputProps={{
                mask: 'HH:MM',
                blocks: {
                  HH: {
                    mask: IMask.MaskedRange,
                    from: 0,
                    to: 99,
                    maxLength: 2,
                    placeholder: '__',
                  },
                  MM: {
                    mask: IMask.MaskedRange,
                    from: 0,
                    to: 59,
                    maxLength: 2,
                    placeholder: '__',
                  },
                },
              }} />
          </FormControl>
        );
      }} />

  );
}